import React from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { getMagazinesTimeStamp } from "../../../arrow/utils/timestamp-utils";
import { Button } from "../../atoms";
import { STATIC_KEYWORDS } from "../../../constants";
import { RightArrow } from "../../../arrow/components/Svgs/right-arrow";

import "./magazine-story-header-card.m.css";

export const MagazineStoryHeaderCard = ({ magazineDetails }) => {
  const readEmagazineLink = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "read_emagazine_link"], "")
  );
  const cdnImage = useSelector((state) => get(state, ["qt", "config", "cdn-image"], ""));

  const { READ_FULL_E_MAGAZINE } = STATIC_KEYWORDS;

  return (
    <>
      <div styleName="magazine-story-header-card">
        <Link href={`/magazine/${magazineDetails?.slug}`} aria-label="magazine-cover-image" disableAjaxLinks={true}>
          <figure styleName="image-wrapper">
            <img
              src={`https://${cdnImage}/${magazineDetails?.metadata?.["cover-image"]?.["cover-image-s3-key"]}?q=70`}
              alt="magazine-cover-image"
              width={400}
              style={{ aspectRatio: "3/4", objectFit: "cover" }}
            />
          </figure>
        </Link>

        <div>
          <div styleName="magazine-summary">This story belongs to the issue:</div>
          <div styleName="magazine-issue">{getMagazinesTimeStamp(magazineDetails?.["issue-date"])}</div>
          <Button customStyleName={"fit-width"} href={readEmagazineLink}>
            {READ_FULL_E_MAGAZINE}
          </Button>
        </div>
      </div>
      <div styleName="mobile-magazine-header">
        <div styleName="divider"></div>
        <p styleName="mobile-description">
          This story belongs to the Fortune India Magazine {getMagazinesTimeStamp(magazineDetails?.["issue-date"])}{" "}
          issue.{" "}
        </p>
        <div styleName="read-more">
          <Link href={readEmagazineLink} disableAjaxLinks={true}>
            Read Full E-Magazine
          </Link>
          <RightArrow color="#C6554F" />
        </div>
        <div styleName="divider"></div>
      </div>
    </>
  );
};
